export function insertIf(condition, elements) {
  return condition ? elements : [];
}

export function insertIfObj(condition, object) {
  return condition ? object : {};
}
